

import { configureStore } from '@reduxjs/toolkit';

import rules from './rules'; 
import tempRules from './rules/tempRules'; 
import controls from './controls'; 
import tempControls from './controls/tempControls'; 
import colors from './colors';
import aliases from './aliases';
// import controlGroups from './controlGroups'; 
// import tempControlGroups from './controlGroups/tempControlGroups'; 
import data from './data'; 
import devices from './devices'; 
import messages from './messages'; 
import otas from './otas'; 
import settings from './settings'; 
import tempSettings from './settings/tempSettings'; 
// import profile from './profile'; 

import screenState from './screenState'; 
import editLock from './editLock'; 
import uiPrefs from './uiPrefs'; 


const store = configureStore({
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
	reducer: {
		rules,
		tempRules,
		controls,
		tempControls,
		colors,
		aliases,
		// controlGroups,
		// tempControlGroups,
		data,
		devices,
		messages,
		otas,
		settings,
		tempSettings,
		// profile,
		screenState,
		editLock,
		uiPrefs
	}
});

export default store;